/* unplugin-vue-components disabled */import script from "./Tab2.vue?vue&type=script&setup=true&lang=js"
export * from "./Tab2.vue?vue&type=script&setup=true&lang=js"

import "./Tab2.vue?vue&type=style&index=0&id=1788b7be&lang=scss&rel=stylesheet%2Fscss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1788b7be"]])

export default __exports__